import { useTracking } from 'lib/analytics/Tracker';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import MainLayout from 'components/layout/MainLayout';
import { makeStyles } from '@material-ui/core/styles';
import ENV from '../constants/Env';

const useStyles = makeStyles(theme => ({
  iframe: {
    minHeight: '100%',
    width: '100%',
    border: 'none',
  },
}));

function CustodianProfileContainer() {
  const tracker = useTracking();
  const history = useHistory();
  const classes = useStyles();

  useEffect(() => {
    tracker.track('Coordinator Profile Viewed');
  }, [tracker]);

  useEffect(() => {
    window.addEventListener(
      'message',
      event => {
        if (event.origin !== ENV.portalUrl) {
          return;
        }

        const { data } = event;

        if (data.action === 'USER_UPDATED') {
          history.push('/');
        }
      },
      false,
    );
  }, []);

  /*
   * The `embeddedInDashboard=true` query param tells Portal that we are embedding into dashboard
   * which keeps the portal sidebar hidden and uses portal redirects to dashboard.
   */
  return (
    <MainLayout usePadding="no">
      <iframe
        data-test-id="portal-iframe"
        title="User Settings Screen"
        src={`${ENV.portalUrl}/user-settings?embeddedInDashboard=true`}
        className={classes.iframe}
      />
    </MainLayout>
  );
}

export default CustodianProfileContainer;
